<template>
  <div class="relative-position cursor-pointer">
    <q-knob
      :model-value="progressValue"
      :max="1"
      :min="0"
      :size="`${size}px`"
      :thickness="0.25"
      :color="meterColor"
      track-color="grey-4"
      readonly
    />

    <q-menu anchor="bottom middle" self="top middle" :offset="[0, 6]">
      <div>
        <q-card flat bordered style="min-width: 220px; max-width: 400px">
          <q-card-section class="q-pb-xs">
            <div class="text-subtitle2">{{ title }}</div>
          </q-card-section>
          <q-separator />
          <q-card-section class="q-pt-sm">
            <div class="row items-center justify-between q-mb-sm">
              <span class="text-body2 q-mr-sm">{{ usageLabel }}</span>
              <q-badge :color="meterColor" outline>{{ remaining }} remaining</q-badge>
            </div>
            <q-linear-progress
              :value="progressValue"
              :color="meterColor"
              size="6px"
              rounded
              :animation-speed="0"
            />
          </q-card-section>
          <q-card-section v-if="limitReached && helpText" class="q-pt-xs text-body2">
            {{ helpText }}
          </q-card-section>
        </q-card>
      </div>
    </q-menu>
  </div>
</template>

<script lang="ts">
export default {
  name: 'UsageMeter',
  props: {
    current: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: 'Usage'
    },
    helpText: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 42
    }
  },
  computed: {
    progressValue(): number {
      if (this.limit <= 0) {
        return 0
      }
      return Math.min(1, this.current / this.limit)
    },
    remaining(): number {
      return Math.max(0, this.limit - this.current)
    },
    limitReached(): boolean {
      return this.current >= this.limit
    },
    meterColor(): string {
      if (this.limitReached) {
        return 'negative'
      }
      if (this.progressValue >= 0.8) {
        return 'warning'
      }
      return 'primary'
    },
    usageLabel(): string {
      return `${this.current} of ${this.limit} ${this.limit === 1 ? 'report' : 'reports'} used`
    }
  }
}
</script>
